import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'itemName'
})
export class ItemNamePipe implements PipeTransform {

  transform(value: any, attributeId: string, attributeName: string, data: Array<any> = []): string {
    const itemFound = data.find(item => {
        return item.hasOwnProperty(attributeId) && item[attributeId] == value;
    });
    if(itemFound && itemFound.hasOwnProperty(attributeName)){
      return itemFound[attributeName];
    }
    return '';
  }

}
